<template>
  <section>
    <div class="spacer top"><h1 class="title">CONTACTS</h1></div>

    <div class="cntr">
      <Map></Map>
    </div>

    <div class="spacer">
      <a href="https://github.com/dyushchev" target="_blank">
        <svg
          class="svg-logo"
          @mouseenter="gitMouseEnter"
          @mouseleave="gitMouseLeave"
          width="64"
          height="64"
          fill="none"
          version="1.1"
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill-rule="evenodd" shape-rendering="auto">
            <path
              d="m512-6.9121c-137.62 0-269.61 54.673-366.93 151.99-97.313 97.313-151.99 229.3-151.99 366.93s54.673 269.61 151.99 366.93c97.313 97.313 229.3 151.99 366.93 151.99s269.61-54.673 366.93-151.99 151.99-229.3 151.99-366.93-54.673-269.61-151.99-366.93c-97.313-97.313-229.3-151.99-366.93-151.99zm0 13.824c133.96 0 262.43 53.211 357.15 147.94 94.724 94.724 147.94 223.19 147.94 357.15s-53.211 262.43-147.94 357.15c-94.724 94.724-223.19 147.94-357.15 147.94s-262.43-53.211-357.15-147.94c-94.724-94.724-147.94-223.19-147.94-357.15s53.211-262.43 147.94-357.15c94.724-94.724 223.19-147.94 357.15-147.94z"
              color="#000000"
              color-rendering="auto"
              dominant-baseline="auto"
              image-rendering="auto"
              solid-color="#000000"
              stop-color="#000000"
              style="
                font-feature-settings: normal;
                font-variant-alternates: normal;
                font-variant-caps: normal;
                font-variant-east-asian: normal;
                font-variant-ligatures: normal;
                font-variant-numeric: normal;
                font-variant-position: normal;
                font-variation-settings: normal;
                inline-size: 0;
                isolation: auto;
                mix-blend-mode: normal;
                paint-order: stroke markers fill;
                shape-margin: 0;
                shape-padding: 0;
                text-decoration-color: #000000;
                text-decoration-line: none;
                text-decoration-style: solid;
                text-indent: 0;
                text-orientation: mixed;
                text-transform: none;
                white-space: normal;
              "
            />
            <path
              d="m1024 512c0 135.79-53.943 266.02-149.96 362.04-96.019 96.019-226.25 149.96-362.04 149.96s-266.02-53.943-362.04-149.96c-96.019-96.019-149.96-226.25-149.96-362.04s53.943-266.02 149.96-362.04c96.019-96.019 226.25-149.96 362.04-149.96s266.02 53.943 362.04 149.96c96.019 96.019 149.96 226.25 149.96 362.04z"
              color="#000000"
              color-rendering="auto"
              dominant-baseline="auto"
              fill="#fff"
              image-rendering="auto"
              solid-color="#000000"
              stop-color="#000000"
              style="
                font-feature-settings: normal;
                font-variant-alternates: normal;
                font-variant-caps: normal;
                font-variant-east-asian: normal;
                font-variant-ligatures: normal;
                font-variant-numeric: normal;
                font-variant-position: normal;
                font-variation-settings: normal;
                inline-size: 0;
                isolation: auto;
                mix-blend-mode: normal;
                paint-order: stroke markers fill;
                shape-margin: 0;
                shape-padding: 0;
                text-decoration-color: #000000;
                text-decoration-line: none;
                text-decoration-style: solid;
                text-indent: 0;
                text-orientation: mixed;
                text-transform: none;
                white-space: normal;
              "
            />
          </g>
          <path
            id="gitstart"
            ref="gitstart"
            transform="scale(64)"
            d="m8 0c-4.42 0-8 3.58-8 8 0 3.54 2.29 6.53 5.47 7.59 0.4 0.07 0.55-0.17 0.55-0.38 0-0.19-0.01-0.82-0.01-1.49-2.01 0.37-2.53-0.49-2.69-0.94-0.09-0.23-0.48-0.94-0.82-1.13-0.28-0.15-0.68-0.52-0.01-0.53 0.63-0.01 1.08 0.58 1.23 0.82 0.72 1.21 1.87 0.87 2.33 0.66 0.07-0.52 0.28-0.87 0.51-1.07-1.78-0.2-3.64-0.89-3.64-3.95 0-0.87 0.31-1.59 0.82-2.15-0.08-0.2-0.36-1.02 0.08-2.12 0 0 0.67-0.21 2.2 0.82 0.64-0.18 1.32-0.27 2-0.27s1.36 0.09 2 0.27c1.53-1.04 2.2-0.82 2.2-0.82 0.44 1.1 0.16 1.92 0.08 2.12 0.51 0.56 0.82 1.27 0.82 2.15 0 3.07-1.87 3.75-3.65 3.95 0.29 0.25 0.54 0.73 0.54 1.48 0 1.07-0.01 1.93-0.01 2.2 0 0.21 0.15 0.46 0.55 0.38 3.16-1.06 5.45-4.06 5.45-7.59 0-4.42-3.58-8-8-8z"
            clip-rule="evenodd"
            fill="#505050"
            fill-rule="evenodd"
          />
          <path
            id="gitend"
            ref="gitend"
            d="m512 0c-282.88 0-512 229.12-512 512 0 226.56 146.58 417.92 350.1 485.76 25.6 4.48 35.19-10.893 35.19-24.333 0-12.16-0.61906-52.453-0.61906-95.333-128.64 23.68-161.95-31.39-172.19-60.19-5.76-14.72-30.716-60.126-52.476-72.286-17.92-9.6-43.499-33.312-0.6191-33.952 40.32-0.64 69.114 37.116 78.714 52.476 46.08 77.44 119.7 55.678 149.14 42.238 4.48-33.28 17.899-55.676 32.619-68.476-62.595-7.0331-126.62-23.691-171.71-69.619-92.589 17.949-155.62 51.19-155.62 51.19s20.574-13.812 46.238-25.095c12.997-5.7138 58.509-22.994 98.714-33.19 1.2157-0.3083 2.2713-0.46697 3.4762-0.76191-4.4347-5.0818-8.685-10.436-12.667-16.19-90.37 9.4468-153.33 35.095-153.33 35.095s21.836-11.699 48.476-20.429c13.286-4.3537 59.018-16.765 99.571-23.095-4.4714-7.2446-8.6048-14.989-12.333-23.286-88.944 4.6448-151.67 26.143-151.67 26.143s22.473-10.483 49.572-17.667c13.242-3.5105 58.008-12.869 98.238-17-12.605-31.643-19.905-70.586-19.905-118.86 0-55.68 19.836-101.78 52.476-137.62-5.12-12.8-23.065-65.267 5.0952-135.67 0 0 42.89-13.444 140.81 52.476 40.96-11.52 84.48-17.286 128-17.286s87.04 5.7657 128 17.286c97.92-66.56 140.81-52.476 140.81-52.476 28.16 70.4 10.263 122.87 5.1428 135.67 32.64 35.84 52.476 81.299 52.476 137.62 0 48.451-7.3256 87.509-20 119.19 39.569 4.2567 82.747 13.229 95.714 16.667 27.098 7.184 49.571 17.667 49.571 17.667s-61.498-21.081-149.1-26c-3.7848 8.4061-7.9761 16.248-12.524 23.571 39.954 6.4347 84.161 18.397 97.19 22.667 26.641 8.7297 48.476 20.429 48.476 20.429s-61.812-25.21-150.9-34.857c-4.0559 5.839-8.3816 11.286-12.905 16.429 0.44924 0.11242 0.83504 0.17143 1.2857 0.2857 40.205 10.196 85.717 27.477 98.714 33.19 25.664 11.283 46.238 25.095 46.238 25.095s-62.068-32.716-153.48-50.762c-45.255 45.731-109.39 62.166-171.9 69.19 18.56 16 34.571 46.762 34.571 94.762 0 68.48-0.66665 123.48-0.66665 140.76 0 13.44 9.6381 29.453 35.238 24.333 202.24-67.84 348.76-259.84 348.76-485.76 0-282.88-229.12-512-512-512zm-140.52 399.81c-55.306-0.36005-102.1 12.354-121.62 18.905-116.49 38.884 9.6544 160.67 78.238 161.81 51.903 0.86211 163.63-71.219 174.29-122.24h23.571c10.666 51.029 122.43 123.1 174.33 122.24 68.584-1.1392 194.73-122.93 78.238-161.81-19.523-6.5503-66.36-19.265-121.67-18.905-33.184 0.21604-69.428 5.1632-104.67 18.905-13.525 5.2741-21.35 12.419-24.905 20.762h-25.714v1.0952c-3.3112-8.8122-11.316-16.354-25.429-21.857-35.239-13.742-71.483-18.689-104.67-18.905zm143.14 144.95s-27.847 0.70834-45.81 10.429c-17.962 9.7202-21.661 22.977-15.476 32.143 6.7362 9.9824 43.456 37.49 61.286 41.095 17.83-3.6054 54.549-31.113 61.286-41.095 6.1852-9.1661 2.4863-22.423-15.476-32.143-17.962-9.7202-45.81-10.429-45.81-10.429zm-5.5238 193.62c-6.8656 0.0891-12.372 7e-3 -18.095 0.33334-4.2119 0.1219-14.553 3.9915-9.6667 19.905 4.8862 15.913 1.1586 18.499 24.571 29.524-14.132 52.631-42.342 102.49-54.952 154.38 0 0 48.619 26.628 58.143 31 9.5234-4.3719 58.143-31 58.143-31-12.61-51.89-40.821-101.75-54.952-154.38 23.413-11.025 19.685-13.611 24.571-29.524 4.8863-15.913-5.4548-19.783-9.6667-19.905-5.7233-0.32629-11.23-0.24313-18.095-0.33334z"
            fill="#505050"
            stroke-width="64"
          /></svg
      ></a>

      <a href="https://www.linkedin.com/in/dmitry-seattle/" target="_blank">
        <div class="svg-logo">
          <img src="../assets/in.png" alt="" />
        </div>
      </a>

      <!-- <a href="https://www.linkedin.com/in/dmitry-seattle/">
        <div class="img">
          <img src="../assets/code.png" alt="" />
        </div>
      </a> -->
    </div>
  </section>
</template>

<script>
import Map from "../components/Map.vue"

export default {
  components: {
    Map
  },
  data () {
    return {
      popupPresent: false,
    }
  }, methods: {
    gitMouseEnter () {
      this.$refs.gitend.style.setProperty('visibility', 'visible')
    },
    gitMouseLeave () {
      this.$refs.gitend.style.setProperty('visibility', 'hidden')
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/mixin.scss";

.message-popup {
  z-index: 1000;
}

section {
  @include center-v;
  display: flex;
  align-items: flex-end;
  background-color: rgb(255, 255, 255);
  height: 100vh;

  .title {
    @include section-title;
  }

  h1 {
    font-size: 10em;
  }

  .spacer {
    @include flex-center;
    width: calc(95vw);
    height: 25vh;
    right: 0;
    display: flex;
    justify-content: center;

    .svg-logo {
      @include flex-center;
      border-radius: 50%;
      width: 3rem;
      height: 3rem;
      margin: 5rem 0;
      opacity: 0.3;
      z-index: 10000;

      &:hover {
        @include shadow;
        @include svg-hover;
        opacity: 0.8 !important;
        border-radius: 50%;
        border: 0.3rem $primary-dark solid;
        background-color: rgb(255, 255, 255);
      }

      @media only screen and (max-width: 600px) {
        margin: 5rem 0.5rem;
        width: 3rem;
        height: 3rem;
      }
      @media only screen and (min-width: 600px) {
        margin: 5rem 1rem;
      }
    }
  }

  .top {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .cntr {
    @include flex-center;
    height: 50%;
    width: 100%;
  }
}

#gitend {
  visibility: hidden;
}
</style>